import Modal from './modal';
const setupFilters = () => {
    const checkboxes = document.querySelectorAll('.terms_child_item-categorie input[type="checkbox"], .terms_list_item-tag input[type="checkbox"]');
    const resetButton = document.querySelector('#resetButton');
    const searchInput = document.querySelector('#searchInput');

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function () {
            if (resetButton) {
                resetButton.checked = false;
            }
            applyFilters();
        });
    });

    if (resetButton) {
        resetButton.addEventListener('change', function () {
            if (resetButton.checked) {
                resetFilters();
            } else {
                applyFilters();
            }
        });
    }

    if (searchInput) {
        searchInput.addEventListener('input', function () {
            if (searchInput.value === '') {
                if (resetButton) {
                    resetButton.checked = true;
                }
                resetFilters();
            } else {
                if (resetButton) {
                    resetButton.checked = false;
                }
                applyFilters();
            }
        });
    }
};

const applyFilters = () => {
    if (typeof ajax_params === 'undefined') {
        console.error('ajax_params is not defined.');
        return;
    }

    const selectedCategories = [];
    const selectedTags = [];
    const searchTerm = document.querySelector('#searchInput') ? document.querySelector('#searchInput').value : '';

    document.querySelectorAll('.terms_child_item-categorie input[type="checkbox"]:checked').forEach(checkbox => {
        selectedCategories.push(checkbox.value);
    });

    document.querySelectorAll('.terms_list_item-tag input[type="checkbox"]:checked').forEach(checkbox => {
        selectedTags.push(checkbox.value);
    });

    console.log('Selected Categories:', selectedCategories.join(','));
    console.log('Selected Tags:', selectedTags);
    console.log('Search Term:', searchTerm);

    fetch(ajax_params.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: new URLSearchParams({
            action: 'filter_mediatheques',
            categories: selectedCategories.join(','),
            tags: selectedTags.join(','),
            search: searchTerm
        })
    })
        .then(response => response.json())
        .then(data => {
            const gridPosts = document.querySelector('.grid_posts');
            if (gridPosts) {
                gridPosts.innerHTML = data.content;
                initializeModalEvents(); // Réattache les événements des boutons modaux
            } else {
                console.error('grid_posts element not found.');
            }
        })
        .catch(error => console.error('Error:', error));
};

const resetFilters = () => {
    const checkboxes = document.querySelectorAll('.terms_child_item-categorie input[type="checkbox"], .terms_list_item-tag input[type="checkbox"]');
    const searchInput = document.querySelector('#searchInput');

    checkboxes.forEach(checkbox => {
        checkbox.checked = false;
    });

    if (searchInput) {
        searchInput.value = '';
    }

    console.log('Filters reset, fetching all posts.');

    fetch(ajax_params.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: new URLSearchParams({
            action: 'filter_mediatheques',
            categories: '',
            tags: '',
            search: ''
        })
    })
        .then(response => response.json())
        .then(data => {
            console.log('Data received after reset:', data);
            const gridPosts = document.querySelector('.grid_posts');
            if (gridPosts) {
                gridPosts.innerHTML = data.content;
                initializeModalEvents(); // Réattache les événements des boutons modaux
            } else {
                console.error('grid_posts element not found.');
            }
        })
        .catch(error => console.error('Error:', error));
};

const initializeModalEvents = () => {
    document.querySelectorAll('.btn-modal').forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            const videoUrl = button.getAttribute('data-video-url');
            const modalInstance = new Modal(); // Assurez-vous que votre classe Modal est accessible ici
            modalInstance.openModal(videoUrl);
        });
    });
};

// Export des fonctions
export { setupFilters, applyFilters, resetFilters };
